import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ONRAMPER_QUERY_PARAM, convertJSONToQueryParam } from './onramper.config';
import { v4 as uuidv4 } from 'uuid';
import { Observable, first, switchMap, takeWhile, timer } from 'rxjs';
import { OnramperService } from 'app/services/onramper/onramper.service';
import { CoinService } from 'app/services/coin/coin.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { contractAddress } from 'app/services/contract/contract.config';
import { PancakeV2Service } from 'app/services/contract/contracts-services/pancake.service';
import { SpinnerService } from 'app/services/spinner/spinner.service';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';

@Component({
  selector: 'onramper',
  templateUrl: './onramper.component.html',
  styleUrls: ['./onramper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OnramperComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Output() isVisible: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() amountSelected: number;
  @Input() wallet: string;
  @Input() kmonPriceData: any;
  srcOnramper: SafeResourceUrl;
  onramperQueryParam: { [key: string]: string } = ONRAMPER_QUERY_PARAM();
  partnerContext: string;
  onramperQUeryParamString: string;

  constructor(
    private sanitizer: DomSanitizer,
    private onramperService: OnramperService,
    private web3Service: Web3Service,
    private pancakeV2Service: PancakeV2Service,
    private spinnerService: SpinnerService,
    private toastService: ToastService,
    private tokenService: TokenService
  ) { }


  ngOnInit(): void {
    this.pancakeV2Service.isConversionCompleted$.subscribe(
      isCompleted => {
        if (isCompleted) this.tokenService.KMONbalance(this.wallet).pipe(first()).subscribe();//to refresh Kmon balance
      }
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.amountSelected && this.wallet && this.visible) {
      this.srcOnramper = this.getSrcOnramper();
    }
  }
  onHide() {
    this.isVisible.emit(this.visible);
    this.checkOnramperTransactionStatus();
  }

  getSrcOnramper(): SafeResourceUrl {
    this.partnerContext = uuidv4();
    // this.onramperQueryParam['defaultAmount'] = '';
    this.onramperQueryParam['defaultAmount'] = this.amountSelected.toString();
    this.onramperQueryParam['networkWallets'] = ONRAMPER_QUERY_PARAM()['networkWallets'];
    this.onramperQueryParam['networkWallets'] += this.wallet;
    this.onramperQueryParam['partnerContext'] = this.partnerContext;
    // console.log(this.onramperQueryParam);
    this.onramperQUeryParamString = convertJSONToQueryParam(this.onramperQueryParam);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://buy.onramper.com/?' + this.onramperQUeryParamString
    );
  }

  checkOnramperTransactionStatus() {
    const maxAttempts = 20;
    const interval = 6000; // 6 seconds
    let attempts = 0;
    this.spinnerService.setSpinner(true);
    let bnbAmount = (this.amountSelected - 5) / this.kmonPriceData.wbnb.usd * 1.05;
    timer(0, interval)
      .pipe(
        takeWhile(() => attempts < maxAttempts),
        switchMap(() => this.onramperService.checkStatus(this.partnerContext))
      )
      .subscribe(
        response => {
          if (response.status === 'completed') {
            console.log('attempts: ' + attempts);
            this.spinnerService.setSpinner(false);

            //Convert directly
            this.convertBNBtoKMON(bnbAmount).subscribe()
            attempts = maxAttempts;
          } else if (response.status === 'pending') {
            attempts++;
            console.log(`Attempt ${attempts} - answer: ${response.status}`);

          } else {
            this.spinnerService.setSpinner(false);
            this.toastService.genericError();
          }
        },
        error => {
          this.spinnerService.setSpinner(false);
          if (error.status === 404) console.error('Transaction not executed:', error);

        }
      );
  }

  convertBNBtoKMON(bnbAmount): Observable<any> {
    let _contractAddress = contractAddress[this.web3Service.getNetworkName()];
    let bnbAddress = _contractAddress.WBNB;
    let kmonAddress = _contractAddress.KMONToken;
    return this.pancakeV2Service.swapExactETHForTokens(
      0.8, this.kmonPriceData.kryptomon.bnb, this.wallet, 600, bnbAmount, kmonAddress, bnbAddress);
  }

}
